module.exports = __webpack_public_path__ + "static/chef-64b9f055c319c78c76eff5777265b519.png";